/* src/app/shared/components/debug-tools/claims-json-validator/claims-json-validator.component.scss */
form {
  margin: 1em 0;
}
form .data {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 1em;
}
@media screen and (min-width: 48rem) {
  form .data {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
  }
}
form .data .textarea-field {
  flex: 1;
}
form ::ng-deep .mat-mdc-form-field.textarea-field {
  height: 17em;
}
form ::ng-deep .mat-mdc-form-field.textarea-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix textarea {
  max-height: 15em;
  overflow: auto;
}
form .results {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 1em;
  padding: 1em 0;
}
@media screen and (min-width: 48rem) {
  form .results {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
  }
}
form .results .json {
  flex: 1;
  max-height: 15em;
  overflow: auto;
  border: solid thin #e0e0e0;
}
form .results .errors {
  flex: 1;
  padding: 1em 0;
  max-height: 15em;
  overflow: auto;
}
:host(.claims-json-validator) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: auto;
  font-size: 1rem;
  padding: 1em;
}
/*# sourceMappingURL=claims-json-validator.component.css.map */
